import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 13,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 11,
          day: 22,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 2,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 1,
          day: 17,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 20,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 20,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'red',
        date: {
          year: 2011,
          month: 6,
          day: 13,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 11,
          day: 22,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 2,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 1,
          day: 17,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 20,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 20,
        },
      },
    ],
  },
};
